import React from "react";
import { Box, Typography } from "@material-ui/core";
import { ErrorMessage, useFormikContext } from "formik";
import {
  OrganizationUserSearch,
  GetNextAvailableOrderInRotation,
} from "../../../../../Services";
import {
  ReskinningInputs,
  FBFieldWrapper,
  CustomCheckbox,
  CustomCard,
  CustomSwitch,
  CustomAsyncAutocomplete,
} from "../../../../../Components";
import { useVerticalNav } from "../../../../../Contexts/VerticalNavContext";
import { useTranslate } from "../../../../../Hooks";

import useStyles from "../styles";

function MandatoryFields() {
  const { setFieldValue, handleChange, handleBlur, errors, values } =
    useFormikContext();
  const { setAlertBoxContent } = useVerticalNav();

  const { translate } = useTranslate("NewAgentsRotationCriteria");
  const styles = useStyles();

  return (
    <>
      <CustomCard
        boxShadow="xs"
        borderRadius="xl"
        borderColor="secondary"
        classes={styles.mandotaryForm}
      >
        <Typography
          className={styles.secondaryTitle}
          variant="h6"
          component="h3"
        >
          {translate("rotation-form-Mandatory-section-heading")}
        </Typography>
        <ReskinningInputs
          name="label"
          idRef="label"
          labelValue={translate("rotation-label")}
          value={values.label}
          inputPlaceholder={translate("enter")}
          fieldClasses={styles.inputwrapper}
          rootCustomClasses={styles.inputwrapper}
          onInputChanged={handleChange}
          onInputBlur={handleBlur}
          isWithError={!!errors.label}
          error={!!errors.label}
          helperText={errors.label}
          forceError={errors.label}
        />
        <ReskinningInputs
          value={values.order}
          name="order"
          idRef="order"
          type="number"
          labelValue={translate("schema-order-label")}
          fieldClasses={styles.inputwrapper}
          rootCustomClasses={styles.inputwrapper}
          textFieldWrapperClass={styles.textFieldWrapper}
          onInputChanged={handleChange}
          inputPlaceholder={0}
          onInputBlur={handleBlur}
          isWithError={Boolean(errors.order)}
          error={Boolean(errors.order)}
          helperText={errors.order}
          forceError={errors.order}
          buttonOptions={{
            className: styles.viewOrderButton,
            text: translate("view"),
            onActionClicked: async () => {
              const res = await GetNextAvailableOrderInRotation();
              if (!(res && res.status && res.status !== 200)) {
                setFieldValue("order", String(res));
                setAlertBoxContent({
                  display: true,
                  variant: "success",
                  title: translate("next-Available-Order") + res,
                  onClose: () => {
                    setAlertBoxContent(null);
                  },
                });
              } else {
                setAlertBoxContent({
                  display: true,
                  variant: "error",
                  title: translate("something-went-wrong"),
                  onClose: () => {
                    setAlertBoxContent(null);
                  },
                });
              }
            },
          }}
        />
        <Box className={styles.checkboxWrapper}>
          <label className={styles.fieldLabel}>
            {translate("lead-type-label")}
          </label>
          <CustomCheckbox
            name="buyer"
            checked={values.buyer}
            onChange={handleChange}
          />
          <span className={styles.checkboxLabel}>{translate("buyer")}</span>
          <CustomCheckbox
            name="tenant"
            checked={values.tenant}
            onChange={handleChange}
          />
          <span className={styles.checkboxLabel}>{translate("tenant")}</span>
          <ErrorMessage name="buyer">
            {(err) => <div className={styles.errorMessage}>{err}</div>}
          </ErrorMessage>
        </Box>
        <Box className={styles.checkboxWrapper}>
          <label className={styles.fieldLabel}>
            {translate("lead-class-label")}
          </label>
          <CustomCheckbox
            name="normal"
            checked={values.normal}
            onChange={handleChange}
          />
          <span className={styles.checkboxLabel}>{translate("normal")}</span>
          <CustomCheckbox
            name="vip"
            checked={values.vip}
            onChange={handleChange}
          />
          <span className={styles.checkboxLabel}>{translate("vip")}</span>
          <CustomCheckbox
            name="vvip"
            checked={values.vvip}
            onChange={handleChange}
          />
          <span className={styles.checkboxLabel}>{translate("VVIP")}</span>
          <ErrorMessage name="vip">
            {(err) => <div className={styles.errorMessage}>{err}</div>}
          </ErrorMessage>
        </Box>
        <FBFieldWrapper
          rootCustomClasses={styles.inputwrapper}
          labelPosition="side"
          label={translate("all-bulk-leads-label")}
        >
          <CustomSwitch
            label={translate("accept-bulk")}
            name="isBulk"
            size={"md"}
            checked={values.isBulk}
            onChange={(e) => setFieldValue("isBulk", Number(e.target.checked))}
          />
        </FBFieldWrapper>
        <CustomAsyncAutocomplete
          labelValue={translate("referred-by-label")}
          rootCustomClasses={styles.inputwrapper}
          multiple
          selectedValues={values.rotationSchemaReferredBys}
          onChange={(_e, value) =>
            setFieldValue("rotationSchemaReferredBys", value)
          }
          mapper={(data) => {
            return data.map((item) => ({
              userId: item.id,
              fullName: item.fullName,
            }));
          }}
          queryKey={"name"}
          onFetchData={OrganizationUserSearch}
          filter={{ pageIndex: 0, pageSize: 50, userStatusId: 2 }}
          displayLabel={(option) => option?.fullName ?? ""}
          renderOption={(option) => option?.fullName}
          chipsLabel={(option) => {
            return option?.fullName;
          }}
          getOptionSelected={(option, value) =>
            option?.userId === value?.userId
          }
          refetchOnSearch
          error={Boolean(errors.rotationSchemaReferredBys)}
          withError={Boolean(errors.rotationSchemaReferredBys)}
          helperText={errors.rotationSchemaReferredBys}
          forceError={errors.rotationSchemaReferredBys}
        />
      </CustomCard>
    </>
  );
}

export default MandatoryFields;
